const richtext = "dibr1i4qwmu";

export { richtext };
import "./richtext.style.linaria.module.css";
//# sourceMappingURL=richtext.style.js.map
